import styled from 'styled-components';

export const FormContent = styled.form`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.35rem 1rem;
  align-items: start;

  /* Os campos seguem a largura da célula do grid, não a largura em % que
     cada um traz por padrão. */
  > div {
    width: 100% !important;
    padding-left: 0;
    padding-right: 0;
  }

  /* E-mail ocupa a linha inteira, abaixo de CEP e telefone. */
  > div:nth-child(3) {
    grid-column: 1 / -1;
  }

  /* Botão simples (fluxo sem CNH) ou o par "Anexar imagem / Pular anexo". */
  > button,
  > div:nth-child(4) {
    grid-column: 1 / -1;
    justify-self: center;
    margin-top: 0.75rem;
  }

  p {
    margin-top: 0.5rem;
    color: var(--feedback-danger);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
`;

export const SkipButton = styled.button`
  background: none;
  border: none;
  color: var(--muted-foreground);
  font-size: 0.85rem;
  cursor: pointer;
  text-decoration: underline;
  padding: 0;

  &:hover {
    color: var(--stone-700);
  }
`;
